export const LIB_VERSION = '1.221.1'; // autogenerated
